import { TGenericFeedback, TLanguage } from 'contexts/app-context/types'
import { LANGUAGE_DICTIONARY, LANGUAGE_OPTIONS } from 'common/constants'

import { ERROR_ICON } from './constants'

const fallbackUnknownErrorPageContent: Record<TLanguage, TGenericFeedback> = {
  'pt-BR': {
    icon: ERROR_ICON,
    iconColor: 'var(--error500)',

    title: 'Ops, algo deu errado',
    details:
      'Ocorreu um erro inesperado. Tente novamente mais tarde ou entre em contato com o suporte.',
    confirmButton: 'Voltar',
  },
  'es-ES': {
    icon: ERROR_ICON,
    iconColor: 'var(--error500)',

    title: 'Vaya, algo salió mal',
    details:
      'Se produjo un error inesperado. Inténtalo de nuevo más tarde o ponte en contacto con el soporte.',
    confirmButton: 'Volver',
  },
  'en-US': {
    icon: ERROR_ICON,
    iconColor: 'var(--error500)',

    title: 'Oops, something went wrong',
    details: 'An unexpected error occurred. Please try again later or contact support.',
    confirmButton: 'Go back',
  },
}

const setFallbackUnknownErrorPageContent = (bridgeLanguage?: TLanguage): TGenericFeedback => {
  const { language } = navigator

  const formatedLanguage = LANGUAGE_DICTIONARY[language]

  const selectedLanguage = (bridgeLanguage ?? formatedLanguage) as TLanguage

  if (!selectedLanguage || !LANGUAGE_OPTIONS.includes(selectedLanguage)) {
    return {
      icon: ERROR_ICON,
      iconColor: 'var(--error500)',
      title: 'Oops, something went wrong',
      details: 'An unexpected error occurred. Please try again later or contact support.',
      confirmButton: 'Go back',
    }
  }

  const content = fallbackUnknownErrorPageContent[selectedLanguage]

  if (!content)
    return {
      icon: ERROR_ICON,
      iconColor: 'var(--error500)',
      title: 'Oops, something went wrong',
      details: 'An unexpected error occurred. Please try again later or contact support.',
      confirmButton: 'Go back',
    }

  return content
}

export { setFallbackUnknownErrorPageContent }
